import { createContext, useState } from "react";
import React from "react";

export const UrlContext = createContext();

export const UrlProvider = ({ children }) => {
  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  let API_URL;
  let URI;

  if (process.env.REACT_APP_ENVIRONMENT === "development") {
    API_URL = "https://test.expertpowerhouse.com/api/";
    URI = "https://client.expertpowerhouse.com/";
  } else if (process.env.REACT_APP_ENVIRONMENT === "production") {
    API_URL = "https://client.expertpowerhouse.com/api/";
    URI = "https://client.expertpowerhouse.com/";
  } else {
    API_URL = "http://localhost:5000/api/";
    URI = "http://localhost:3000/";
  }

  // eph-client-backend has no public/feedback routes; in production they live on the main backend
  const FEEDBACK_API_URL =
    process.env.REACT_APP_ENVIRONMENT === "production" ? "https://tool.expertpowerhouse.com/api/" : API_URL;

  return (
    <UrlContext.Provider value={{ API_URL, URI, FEEDBACK_API_URL }}>
      {children}
    </UrlContext.Provider>
  );
};
